<div style="position:relative;">
    <iframe #frameHtml [src]="safeSrc" frameborder="0" style="width: 100%;" [ngStyle]="{ 'height': frame ? 'calc(100vh - 180px)' : 'calc(100vh - 100px)' }" *ngIf="safeSrc" (load)="loaded()"></iframe>
    <please-wait *ngIf="isFrameLoading" class="no-bg" style="position: absolute; top:0; left:0; right: 0; bottom: 0; padding-top: 10%; background-color: rgba(255,255,255,0.8);"></please-wait>
</div>
